import React from 'react';
import {Card, CardHeader,CardContent} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ResourceUsage from './ResourceUsage';
import { Loader } from '../Loading';
import { FormattedMessage } from 'react-intl';
import CircularProgress from '../CircularProgress';

/**
 * View of the resource usage for a subscription
 * Displayed in the subscription page
 * Also displays number of licences / total licences count
 */

const styles = theme => ({
  card: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    borderRadius: 12
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
  },
  resources: {
    display:'flex', 
    flexDirection:'row', 
    justifyContent:'space-evenly', 
    alignContent:'center',
    flexWrap: 'wrap',
  },
  resourceItem: {
    margin:24,
    marginTop:0,
    display:'flex', 
    flexDirection:'column', 
    alignItems:'center'
  },
  usage: {
    marginTop: theme.spacing.unit,
    textAlign: 'center',
  }
})

const ResourcesCard = ({subscription,classes}) => (
  <Card className={classes.card} >
    <CardHeader
      title={
        <Typography variant="h6">
          <FormattedMessage id='subscription.resourceUsage.label' />
        </Typography>
      }
    />
    <CardContent className={classes.content}>
      <div className={classes.resources}>
        {
          subscription.resources
        ? subscription.resources.map(resource=>(
            <div key={resource.id} className={classes.resourceItem}>
              <div>
                <CircularProgress resource={resource} size={80}/>
              </div>
              <div className={classes.usage}>
                <ResourceUsage resource={resource} />
              </div>
            
            </div>
          ))
        : <Loader />
        }
      
      </div>
    </CardContent>
  </Card> 
)

export default withStyles(styles)(ResourcesCard);


// WEBPACK FOOTER //
// ./src/components/resources/ResourcesCard.js